<template>
  <main class="aff-embed-section">
    <div class="aff-embed-container">
      <router-view @loading="changeLoading"></router-view>
      <Loading />
      <Error />
    </div>
  </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import Error from "@/components/message/Error.vue";
import { mapMutations } from "vuex";

export default {
  name: "EmbedPage",
  components: {
    Loading,
    Error,
  },
  methods: {
    ...mapMutations({
      OpenLoading: "OpenLoading",
      CloseLoading: "CloseLoading",
    }),
    changeLoading(bool) {
      if (bool) {
        this.OpenLoading();
      } else {
        this.CloseLoading();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.aff-embed-section {
  background-color: #feffff;
  min-height: 100vh;
  position: relative;
}

.aff-embed-container {
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: 1;
}
</style>
